// Registry of the settings console's sections and panels.
//
// Each panel is a self-contained component hosted by a nested route under
// /Settings (see router.js). `path` must match the child route's path and
// `permission` the route meta — the rail hides items the user can't open.
// Icons are @mdi/font classes (the app's icon font, loaded globally).
//
// To add a panel: build the component, register the child route, add it
// here, and add `layouts.settings-<panel>` i18n keys (en + ar) for the
// NavBar title.
export const SETTINGS_SECTIONS = [
  {
    key: "routing",
    titleKey: "settings.sections.routing",
    items: [
      {
        key: "queues",
        titleKey: "skills.tab_skills",
        icon: "mdi mdi-monitor-multiple",
        path: "queues/manage",
        permission: "J",
      },
      {
        key: "vip",
        titleKey: "smart_routing.tab_vip",
        icon: "mdi mdi-star-outline",
        path: "routing/vip",
        permission: "AD",
      },
      // {
      //   key: "blacklist",
      //   titleKey: "smart_routing.tab_blacklist",
      //   icon: "mdi mdi-cancel",
      //   path: "routing/blacklist",
      //   permission: "AD",
      // },
    ],
  },
  {
    key: "call-handling",
    titleKey: "settings.sections.call_handling",
    items: [
      {
        key: "reasons",
        titleKey: "calls.tab_reasons",
        icon: "mdi mdi-phone-return-outline",
        path: "call-handling/reasons",
        permission: "J",
      },
      // {
      //   key: "crm",
      //   titleKey: "calls.tab_caller_info",
      //   icon: "mdi mdi-cellphone-information",
      //   path: "call-handling/crm",
      //   permission: "J",
      // },
      {
        key: "rating",
        titleKey: "calls.tab_call_rating",
        icon: "mdi mdi-star-settings-outline",
        path: "call-handling/rating",
        permission: "J",
      },
      {
        key: "call-settings",
        titleKey: "settings.call_settings",
        icon: "mdi mdi-cog-outline",
        path: "call-handling/call-settings",
        permission: "J",
      },
    ],
  },
  {
    key: "performance",
    titleKey: "settings.sections.performance",
    items: [
      {
        key: "kpi",
        titleKey: "layouts.kpi-management",
        icon: "mdi mdi-chart-box-outline",
        path: "performance/kpi",
        permission: "J",
      },
    ],
  },
  {
    key: "workforce",
    titleKey: "settings.sections.workforce",
    items: [
      {
        key: "users",
        titleKey: "layouts.Users_Management",
        icon: "mdi mdi-account-multiple",
        path: "workforce/users",
        permission: "I",
      },
      // {
      //   key: "rest-periods",
      //   titleKey: "skills.tab_periods",
      //   icon: "mdi mdi-coffee-outline",
      //   path: "workforce/rest-periods",
      //   permission: "J",
      // },
    ],
  },
  // Pending (routes don't exist in this app yet): System — Domains,
  // Processors (super-admin).
];
